import type { ConditionalWrapperProps } from './ConditionalWrapper.types';

// Helper for conditionally wrapping elements with markup or other components
export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps): JSX.Element =>
  condition ? wrapper(children) : children;
